import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { ModelService } from "../../../../Services/model.service";
import { Message } from "../../../../Model/System/Message";
import { TemplateItemTemplate } from "../../../../Model/Catalog/TemplateItemTemplate";
import { TranslateService } from '@ngx-translate/core';
import { custom } from 'devextreme/ui/dialog';
import { ExportParameter } from "../../../../Model/exportParameter/ExportParameter";
import { LoginService } from "app/Services/login.service";
import { CategoryService } from "app/Services/CatalogManagement/category.service";
import { CatalogService } from "app/Services/CatalogManagement/catalog.service";
import { SystemService } from "app/Services/system.service";
import { FtpServer } from "../../../../Model/FtpServer";
import { FtpServerService } from "../../../../Services/ftp/ftpServer.service";

@Component({
  selector: "exportCategory",
  templateUrl: "exportCategory.component.html",
  styleUrls: ["exportCategory.component.css"]
})
export class ExportCategoryComponent implements OnInit {

  imageTypes = ['jpg', 'png'];

  ftpServers: FtpServer[] = [];

  private _visible: boolean = false;
  public get visible() {
    return this._visible;
  }
  @Input()
  public set visible(val: boolean) {
      if (this._visible !== val) {
          this._visible = val;
          this.visibleChange.emit(val);
      }        
  }
  
  @Output() public visibleChange = new EventEmitter<boolean>();

  @Output() public onValueChanged = new EventEmitter<void>();

  private _model: ExportParameter;
  public get model() {
    return this._model;
  }
  @Input() set model(value: ExportParameter){
    this._model = value;
    this.modelChange.emit(value);
  }
  @Output() public modelChange = new EventEmitter<ExportParameter>();

  @Input() public workflowMode: boolean = false;


  excelIndex: number = 0;
  excelPages: { id: number; title: string; template: string }[] = [];
  groups: string[] = [];

  get listsAreLoaded(): boolean {
    return true;
  }

  showPlaceHolders() {
    return this.loginService.showPlaceHolders;
  }

  get fullScreen() {
    return this.categoryService.viewService.fullScreen;
  }

  constructor(public translate: TranslateService, public loginService: LoginService, public categoryService: CategoryService, public catalogService: CatalogService, public systemService: SystemService,
    public ftpServerService: FtpServerService) {
    this.exportExcel = this.exportExcel.bind(this);
    this.exportCSV = this.exportCSV.bind(this);
    this.saveModel = this.saveModel.bind(this);
    this.saveModelCSV = this.saveModelCSV.bind(this);
    this.reset = this.reset.bind(this);
  }

  async ngOnInit(): Promise<void> {
    this.ftpServerService.getAllServer().subscribe((ftpServer: FtpServer[]) => {
      this.ftpServers = ftpServer;
    });
    await this.templateReset();
    if(!this.model)
      this.model = this.GetExportParameter();
  }

  reset() {
    this.filterReset();
    this.templateReset();
  }

  GetExportParameter(): ExportParameter {
    let result = new ExportParameter();
    result.catalogId = this.catalogService.selectedCatalogId;
    result.customerId = this.loginService.currentUser.customerId;
    result.format = "Bme";
    result.includeMime = false;
    result.orignialSize = true;
    result.maxResolution = 1920;
    result.imageType = "jpg";
    result.imageSquared = false;
    result.imageBgColor = '#FFFFFF';
    result.fields = ['GROUP_ID'];
    result.ftpServerId = -1;
    return result;
  }

  filterReset() {
    this.model.includeMime = false;
  }

  async templateReset() {
    await this.categoryService.loadFields();
    this.initTabView();
    this.groups = ["Basic", "Mimes"];
    if (this.loginService.hasAddonSEO) {
      this.groups.push("Seo");
    }
  }

  initTabView() {
    this.excelPages = [
      { id: 0, title: this.translate.instant("Felder"), template: "excelFieldsTemplate" },
      { id: 1, title: this.translate.instant("Sonstiges"), template: "miscTemplate" }
    ];
    if (this.workflowMode)
      this.excelPages.push({ id: 1, title: this.translate.instant("FTP Server"), template: "ftpTemplate" })
  }

  readOnly(field) {
    return field == "GROUP_ID";
  }

  get fields() {
    return this.categoryService.fields;
  }

  getTemplateItemTemplate(name: string) {
    var element = this.categoryService.fields.filter(item => item.field == name).shift();
    return element;
  }

  exportExcel() {
    this.model.format = "Excel";
    this.startTableExport();
  }

  exportCSV() {
    this.model.format = "csv";
    this.startTableExport();
  }

  startTableExport() {
    this.visible = false;
    this.categoryService.createExportJob(this.model)
      .subscribe(
        () => {
          this.systemService.notify(new Message(this.translate.instant("Der Export wird als Job ausgeführt")));
          this.reset();
        });
  }

  saveModel() {
    this.model.format = "Excel";
    this.onValueChanged.emit();
    this.visible = false;
  }

  saveModelCSV() {
    this.model.format = "csv";
    this.onValueChanged.emit();
    this.visible = false;
  }

  getHeightRatio(group): number {
    var list = this.categoryService.fields.filter(item => item.group == group);
    return list.length + 2;
  }
}
